/**
 * Generated by orval 🍺
 * Do not edit manually.
 * STBportalen
 * OpenAPI spec version: 1.0
 */

export enum ProjectStatus {
  WorkPreparationStarted= 0,
  WorkPreparationFinished= 1,
  Constructed= 2,
  Closed= 3,
  Archived= 4,

}